import {
  isIncrementalVariableValue,
  RequirementCheck,
  RequirementConfig,
  Requirements,
  VariableValues,
} from '../types'

type ItemWithRequirements = {
  requires: Requirements | null
}

const checkRequirement = (
  requirement: RequirementConfig,
  values: VariableValues
) => {
  const { config } = requirement
  const value = values[config?.variable]

  if (!value) {
    return requirement.check == 'none'
  }
  const toCheck = `${value}`?.toLowerCase()

  const isIncremental = isIncrementalVariableValue(value)

  // Lowercase the value to check
  const compare = (v: string) => {
    if (isIncremental) {
      const res = toCheck.includes(v.toLowerCase())
      return res
    }

    return v.toLowerCase() === toCheck
  }

  const checks: Record<RequirementCheck, () => boolean> = {
    any: () => config.values.some(compare),
    none: () => !config.values.some(compare),
  }

  return checks[requirement.check || 'any']()
}

export const checkRequirements = (
  item: ItemWithRequirements,
  values: VariableValues
) => {
  if (!item.requires) {
    return true
  }
  return item.requires.every((requirement) =>
    checkRequirement(requirement, values)
  )
}
